import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-app-redirect',
  templateUrl: './app-redirect.component.html',
  styleUrls: ['./app-redirect.component.css']
})
export class AppRedirectComponent implements OnInit {

  operatingSystem = localStorage.getItem('platform')
  constructor() {

  }

  ngOnInit() {
    if (this.operatingSystem == 'android') {
      window.location.href = environment.production == true ? 'https://libya.hidaya.me/mobileapp/' : 'https://libya-test.hidaya.me/mobileapp/';
    } else if (this.operatingSystem == 'ios') {
      window.location.href = "hidayaLibyaApp://mobileApp"
    } else {
      window.location.href = environment.production == true ? 'https://libya.hidaya.me/mobileapp/' : 'https://libya-test.hidaya.me/mobileapp/';
    }
  }

}
